import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Alert,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Tabs,
  Tab,
  Checkbox,
  ListItemText,
  FormHelperText,
  Chip,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import api from '../config/api';

function Events() {
  const [events, setEvents] = useState([]);
  const [categories, setCategories] = useState([]);
  const [tags, setTags] = useState([]);
  const [orders, setOrders] = useState([]);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    about_event: '',
    event_date: '',
    end_date: '',
    registration_close_date: '',
    location: '',
    venue: '',
    city: '',
    district: '',
    state_id: '',
    district_id: '',
    total_slots: '',
    image_url: '',
    external_url: '',
    social_media_url: '',
    status: 'upcoming',
    category_ids: [],
    tag_ids: [],
    highlights: [],
    schedule: [],
    organizers: [],
    tickets: [],
  });
  const [pullDialogOpen, setPullDialogOpen] = useState(false);
  const [pullFormData, setPullFormData] = useState({
    external_api_url: '',
    api_key: '',
  });
  const [categoryDialogOpen, setCategoryDialogOpen] = useState(false);
  const [tagDialogOpen, setTagDialogOpen] = useState(false);
  const [categoryForm, setCategoryForm] = useState({ id: null, name: '', status: 'active' });
  const [tagForm, setTagForm] = useState({ id: null, name: '', status: 'active' });
  const [orderDialogOpen, setOrderDialogOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orderEventFilter, setOrderEventFilter] = useState('');
  const [coupons, setCoupons] = useState([]);
  const [couponDialogOpen, setCouponDialogOpen] = useState(false);
  const [couponEditing, setCouponEditing] = useState(null);
  const [couponForm, setCouponForm] = useState({
    code: '',
    description: '',
    scope: 'event',
    event_id: '',
    event_category_id: '',
    discount_type: 'percentage',
    discount_value: '',
    max_uses: 100,
    max_uses_per_email: 1,
    valid_from: '',
    valid_until: '',
    status: 'active',
  });
  const [couponError, setCouponError] = useState('');
  const [eventImageFile, setEventImageFile] = useState(null);
  const [organizerImageFiles, setOrganizerImageFiles] = useState([]);
  const [pulling, setPulling] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchEvents();
    fetchCategories();
    fetchTags();
    fetchOrders();
    fetchCoupons();
    fetchStates();
  }, []);

  useEffect(() => {
    if (formData.state_id) {
      fetchDistricts(formData.state_id);
    } else {
      setDistricts([]);
    }
  }, [formData.state_id]);

  const toCommaDisplay = (val) => {
    const arr = Array.isArray(val) ? val : (typeof val === 'string' ? val.split(',').map((f) => f.trim()) : []);
    return arr.join(', ');
  };

  const fetchEvents = async () => {
    try {
      const response = await api.get('/events');
      setEvents(response.data.data || []);
    } catch (error) {
      console.error('Error fetching events:', error);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await api.get('/events/categories');
      setCategories(response.data.data || []);
    } catch (error) {
      console.error('Error fetching event categories:', error);
    }
  };

  const fetchTags = async () => {
    try {
      const response = await api.get('/events/tags');
      setTags(response.data.data || []);
    } catch (error) {
      console.error('Error fetching event tags:', error);
    }
  };

  const fetchOrders = async () => {
    try {
      const response = await api.get('/events/orders');
      setOrders(response.data.data || []);
    } catch (error) {
      console.error('Error fetching event orders:', error);
    }
  };

  const toDatetimeLocalInput = (val) => {
    if (!val) return '';
    const d = new Date(val);
    if (Number.isNaN(d.getTime())) return '';
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  };

  const fetchCoupons = async () => {
    try {
      const response = await api.get('/events/coupons');
      setCoupons(response.data.data || []);
    } catch (error) {
      console.error('Error fetching event coupons:', error);
    }
  };

  const openCouponDialog = (row = null) => {
    if (row) {
      setCouponEditing(row);
      setCouponForm({
        code: row.code || '',
        description: row.description || '',
        scope: row.scope || 'event',
        event_id: row.event_id != null ? String(row.event_id) : '',
        event_category_id: row.event_category_id != null ? String(row.event_category_id) : '',
        discount_type: row.discount_type === 'fixed' ? 'fixed' : 'percentage',
        discount_value: row.discount_value != null ? String(row.discount_value) : '',
        max_uses: row.max_uses != null ? row.max_uses : 100,
        max_uses_per_email: row.max_uses_per_email != null ? row.max_uses_per_email : 1,
        valid_from: toDatetimeLocalInput(row.valid_from),
        valid_until: toDatetimeLocalInput(row.valid_until),
        status: row.status === 'inactive' ? 'inactive' : 'active',
      });
    } else {
      setCouponEditing(null);
      setCouponForm({
        code: '',
        description: '',
        scope: 'event',
        event_id: '',
        event_category_id: '',
        discount_type: 'percentage',
        discount_value: '',
        max_uses: 100,
        max_uses_per_email: 1,
        valid_from: '',
        valid_until: '',
        status: 'active',
      });
    }
    setCouponError('');
    setCouponDialogOpen(true);
  };

  const closeCouponDialog = () => {
    setCouponDialogOpen(false);
    setCouponEditing(null);
    setCouponError('');
  };

  const submitCoupon = async () => {
    try {
      setCouponError('');
      const dv = parseFloat(String(couponForm.discount_value).trim(), 10);
      if (Number.isNaN(dv)) {
        setCouponError('Discount value is required');
        return;
      }
      const payload = {
        code: couponForm.code.trim(),
        description: couponForm.description || null,
        scope: couponForm.scope,
        event_id: couponForm.scope === 'event' ? parseInt(couponForm.event_id, 10) : null,
        event_category_id: couponForm.scope === 'category' ? parseInt(couponForm.event_category_id, 10) : null,
        discount_type: couponForm.discount_type,
        discount_value: dv,
        max_uses: parseInt(couponForm.max_uses, 10) || 100,
        max_uses_per_email: parseInt(couponForm.max_uses_per_email, 10) || 1,
        valid_from: couponForm.valid_from ? new Date(couponForm.valid_from).toISOString().slice(0, 19).replace('T', ' ') : null,
        valid_until: couponForm.valid_until ? new Date(couponForm.valid_until).toISOString().slice(0, 19).replace('T', ' ') : null,
        status: couponForm.status,
      };
      if (couponEditing) {
        await api.put(`/events/coupons/${couponEditing.id}`, payload);
      } else {
        await api.post('/events/coupons', payload);
      }
      closeCouponDialog();
      fetchCoupons();
    } catch (error) {
      setCouponError(error.response?.data?.error || 'Error saving coupon');
    }
  };

  const handleCouponDelete = async (id) => {
    if (!window.confirm('Delete this event coupon?')) return;
    try {
      await api.delete(`/events/coupons/${id}`);
      fetchCoupons();
    } catch (error) {
      console.error('Error deleting coupon:', error);
      window.alert(error.response?.data?.error || 'Delete failed');
    }
  };

  const fetchStates = async () => {
    try {
      const response = await api.get('/locations/states');
      setStates(response.data.data || []);
    } catch (error) {
      console.error('Error fetching states:', error);
    }
  };

  const fetchDistricts = async (stateId) => {
    if (!stateId) {
      setDistricts([]);
      return;
    }
    try {
      const response = await api.get(`/locations/states/${stateId}/districts`);
      setDistricts(response.data.data || []);
    } catch (error) {
      console.error('Error fetching districts:', error);
    }
  };

  const handleOpen = async (event = null) => {
    setError('');
    setEventImageFile(null);
    setOrganizerImageFiles([]);
    if (event?.id) {
      try {
        const response = await api.get(`/events/${event.id}`);
        const details = response.data.data || event;
        setEditing(event);
        setFormData({
          title: details.title || '',
          description: details.description || '',
          about_event: details.about_event || '',
          event_date: details.event_date ? details.event_date.slice(0, 16) : '',
          end_date: details.end_date ? details.end_date.slice(0, 16) : '',
          registration_close_date: details.registration_close_date ? details.registration_close_date.slice(0, 16) : '',
          location: details.location || details.venue || '',
          venue: details.location || details.venue || '',
          city: details.city || '',
          district: details.district || '',
          state_id: details.state_id || '',
          district_id: details.district_id || '',
          total_slots: details.total_slots || '',
          image_url: details.image_url || '',
          external_url: details.external_url || '',
        social_media_url: details.social_media_url || '',
          status: details.status || 'upcoming',
          category_ids: (details.categories || []).map((c) => c.id),
          tag_ids: (details.tags || []).map((t) => t.id),
          highlights: details.highlights || [],
          schedule: details.schedule || [],
          organizers: details.organizers || [],
          tickets: details.tickets || [],
        });
      } catch (error) {
        setError('Failed to load event details.');
      }
    } else {
      setEditing(null);
      setFormData({
        title: '',
        description: '',
        about_event: '',
        event_date: '',
        end_date: '',
        registration_close_date: '',
        location: '',
        venue: '',
        city: '',
        district: '',
        state_id: '',
        district_id: '',
        total_slots: '',
        image_url: '',
        external_url: '',
        social_media_url: '',
        status: 'upcoming',
        category_ids: [],
        tag_ids: [],
        highlights: [],
        schedule: [],
        organizers: [],
        tickets: [],
      });
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEditing(null);
    setError('');
  };

  const validateForm = () => {
    if (!formData.title?.trim()) {
      return 'Title is required.';
    }
    if (!formData.event_date) {
      return 'Event date is required.';
    }
    if (formData.registration_close_date && new Date(formData.registration_close_date) > new Date(formData.event_date)) {
      return 'Registration close date must be before the event date.';
    }
    if (formData.end_date && new Date(formData.end_date) < new Date(formData.event_date)) {
      return 'End date must be after the event date.';
    }
    if (formData.total_slots !== '' && (Number.isNaN(Number(formData.total_slots)) || Number(formData.total_slots) < 0)) {
      return 'Total slots must be a valid non-negative number.';
    }
    if ((formData.highlights || []).some((h) => !(h.highlight_text || h).toString().trim())) {
      return 'Event highlights cannot be empty.';
    }
    if ((formData.schedule || []).some((item) => !item.schedule_time || !item.title)) {
      return 'Each schedule item must include a time and title.';
    }
    if ((formData.tickets || []).some((ticket) => !ticket.title)) {
      return 'Each ticket must include a title.';
    }
    return null;
  };

  const handleSubmit = async () => {
    try {
      setError('');
      const validationError = validateForm();
      if (validationError) {
        setError(validationError);
        return;
      }
      const payload = {
        ...formData,
        total_slots: formData.total_slots === '' ? null : Number(formData.total_slots),
        state_id: formData.state_id === '' ? null : Number(formData.state_id),
        district_id: formData.district_id === '' ? null : Number(formData.district_id),
        category_ids: formData.category_ids || [],
        tag_ids: formData.tag_ids || [],
        highlights: formData.highlights || [],
        schedule: formData.schedule || [],
        organizers: formData.organizers || [],
        tickets: (formData.tickets || []).map((t) => ({
          ...t,
          features: (t.features || []).filter(Boolean),
          tshirt_sizes: (t.tshirt_sizes || []).filter(Boolean),
        })),
      };

      const organizerImageIndices = organizerImageFiles.map((item) => item.index);
      const useMultipart = eventImageFile || organizerImageFiles.length > 0;

      if (useMultipart) {
        const formDataToSend = new FormData();
        Object.keys(payload).forEach((key) => {
          const value = payload[key];
          if (value === undefined) return;
          if (Array.isArray(value) || typeof value === 'object') {
            formDataToSend.append(key, JSON.stringify(value));
          } else if (value !== null && value !== '') {
            formDataToSend.append(key, value);
          } else if (value === null) {
            formDataToSend.append(key, '');
          }
        });

        if (eventImageFile) {
          formDataToSend.append('event_image', eventImageFile);
        }
        organizerImageFiles.forEach((item) => {
          formDataToSend.append('organizer_images', item.file);
        });
        formDataToSend.append('organizer_image_indices', JSON.stringify(organizerImageIndices));

        if (editing) {
          await api.put(`/events/${editing.id}`, formDataToSend, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });
        } else {
          await api.post('/events', formDataToSend, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });
        }
      } else {
        if (editing) {
          await api.put(`/events/${editing.id}`, payload);
        } else {
          await api.post('/events', payload);
        }
      }
      handleClose();
      fetchEvents();
    } catch (error) {
      setError(error.response?.data?.error || 'Error saving event');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this event?')) {
      try {
        await api.delete(`/events/${id}`);
        fetchEvents();
      } catch (error) {
        console.error('Error deleting event:', error);
      }
    }
  };

  const openCategoryDialog = (category = null) => {
    if (category) {
      setCategoryForm({ id: category.id, name: category.name, status: category.status || 'active' });
    } else {
      setCategoryForm({ id: null, name: '', status: 'active' });
    }
    setCategoryDialogOpen(true);
    setError('');
  };

  const handleCategorySave = async () => {
    try {
      if (!categoryForm.name.trim()) {
        setError('Category name is required.');
        return;
      }
      if (categoryForm.id) {
        await api.put(`/events/categories/${categoryForm.id}`, categoryForm);
      } else {
        await api.post('/events/categories', categoryForm);
      }
      setCategoryDialogOpen(false);
      fetchCategories();
    } catch (error) {
      setError(error.response?.data?.error || 'Error saving category');
    }
  };

  const handleCategoryDelete = async (id) => {
    if (window.confirm('Delete this category?')) {
      try {
        await api.delete(`/events/categories/${id}`);
        fetchCategories();
      } catch (error) {
        setError(error.response?.data?.error || 'Error deleting category');
      }
    }
  };

  const openTagDialog = (tag = null) => {
    if (tag) {
      setTagForm({ id: tag.id, name: tag.name, status: tag.status || 'active' });
    } else {
      setTagForm({ id: null, name: '', status: 'active' });
    }
    setTagDialogOpen(true);
    setError('');
  };

  const handleTagSave = async () => {
    try {
      if (!tagForm.name.trim()) {
        setError('Tag name is required.');
        return;
      }
      if (tagForm.id) {
        await api.put(`/events/tags/${tagForm.id}`, tagForm);
      } else {
        await api.post('/events/tags', tagForm);
      }
      setTagDialogOpen(false);
      fetchTags();
    } catch (error) {
      setError(error.response?.data?.error || 'Error saving tag');
    }
  };

  const handleTagDelete = async (id) => {
    if (window.confirm('Delete this tag?')) {
      try {
        await api.delete(`/events/tags/${id}`);
        fetchTags();
      } catch (error) {
        setError(error.response?.data?.error || 'Error deleting tag');
      }
    }
  };

  const openOrderDialog = async (order) => {
    try {
      const response = await api.get(`/events/orders/${order.id}`);
      setSelectedOrder(response.data.data || order);
      setOrderDialogOpen(true);
    } catch (error) {
      setError('Failed to load order details.');
    }
  };

  const getFilteredOrders = () => {
    if (!orderEventFilter) return orders;
    return orders.filter((order) => order.event_id === orderEventFilter);
  };

  const getOrderSummary = (list) => {
    const totalBookings = list.reduce((sum, order) => sum + Number(order.attendees_count || 0), 0);
    const totalIncome = list.reduce((sum, order) => {
      if (order.payment_status === 'success') {
        return sum + Number(order.total_amount || 0);
      }
      return sum;
    }, 0);
    const tshirtBookings = list.reduce((sum, order) => sum + Number(order.tshirt_count || 0), 0);
    const referralBookings = list.reduce((sum, order) => {
      if (order.referred_by_trainer_id || order.referral_code || order.trainer_reference_code) {
        return sum + Number(order.attendees_count || 0);
      }
      return sum;
    }, 0);
    return { totalBookings, totalIncome, tshirtBookings, referralBookings };
  };

  const handleExportOrders = () => {
    const list = getFilteredOrders();
    if (list.length === 0) {
      setError('No orders available to export.');
      return;
    }
    const headers = [
      'Order ID',
      'Event',
      'User Name',
      'User Email',
      'User Phone',
      'Referral Code',
      'Referred Trainer',
      'Coupon Code',
      'Subtotal Before Coupon',
      'Coupon Discount',
      'Total Amount',
      'Payment Status',
      'Redemption At',
      'Attendees Count',
      'Tshirt Count',
      'Tshirt Sizes',
      'Created At'
    ];
    const rows = list.map((order) => [
      order.id,
      order.event_title || '',
      order.user_name || '',
      order.user_email || '',
      order.user_phone || '',
      order.referral_code || order.trainer_reference_code || '',
      order.referred_trainer_name ? `${order.referred_trainer_name}${order.referred_trainer_email ? ' (' + order.referred_trainer_email + ')' : ''}` : '',
      order.coupon_code || '',
      order.subtotal_before_coupon != null ? Number(order.subtotal_before_coupon).toFixed(2) : '',
      order.coupon_discount != null ? Number(order.coupon_discount).toFixed(2) : '',
      Number(order.total_amount || 0).toFixed(2),
      order.payment_status || '',
      order.coupon_redeemed_at ? new Date(order.coupon_redeemed_at).toLocaleString() : '',
      Number(order.attendees_count || 0),
      Number(order.tshirt_count || 0),
      order.tshirt_sizes || '',
      order.created_at ? new Date(order.created_at).toLocaleString() : ''
    ]);

    const csvContent = [headers, ...rows]
      .map((row) => row.map((value) => `"${String(value).replace(/"/g, '""')}"`).join(','))
      .join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'event-orders.csv';
    link.click();
    URL.revokeObjectURL(url);
  };

  const handleOrderPaymentUpdate = async () => {
    if (!selectedOrder?.id) return;
    try {
      await api.put(`/events/orders/${selectedOrder.id}/payment`, {
        payment_status: selectedOrder.payment_status,
        payment_provider: selectedOrder.payment_provider,
        payment_id: selectedOrder.payment_id,
        payment_signature: selectedOrder.payment_signature,
      });
      setOrderDialogOpen(false);
      fetchOrders();
    } catch (error) {
      setError(error.response?.data?.error || 'Error updating payment status');
    }
  };

  const handlePullEvents = async () => {
    try {
      setPulling(true);
      setError('');
      const response = await api.post('/events/pull-all', pullFormData);
      alert(`Events pulled successfully!\nImported: ${response.data.data.imported}\nUpdated: ${response.data.data.updated}\nSkipped: ${response.data.data.skipped}`);
      setPullDialogOpen(false);
      setPullFormData({ external_api_url: '', api_key: '' });
      fetchEvents();
    } catch (error) {
      setError(error.response?.data?.error || 'Error pulling events');
    } finally {
      setPulling(false);
    }
  };

  const updateHighlight = (index, value) => {
    const next = [...(formData.highlights || [])];
    next[index] = { highlight_text: value };
    setFormData({ ...formData, highlights: next });
  };

  const addHighlight = () => {
    setFormData({ ...formData, highlights: [...(formData.highlights || []), { highlight_text: '' }] });
  };

  const removeHighlight = (index) => {
    const next = [...(formData.highlights || [])];
    next.splice(index, 1);
    setFormData({ ...formData, highlights: next });
  };

  const updateSchedule = (index, key, value) => {
    const next = [...(formData.schedule || [])];
    next[index] = { ...next[index], [key]: value };
    setFormData({ ...formData, schedule: next });
  };

  const addScheduleItem = () => {
    setFormData({
      ...formData,
      schedule: [...(formData.schedule || []), { schedule_time: '', title: '', short_description: '' }]
    });
  };

  const removeScheduleItem = (index) => {
    const next = [...(formData.schedule || [])];
    next.splice(index, 1);
    setFormData({ ...formData, schedule: next });
  };

  const updateOrganizer = (index, key, value) => {
    const next = [...(formData.organizers || [])];
    next[index] = { ...next[index], [key]: value };
    setFormData({ ...formData, organizers: next });
  };

  const addOrganizer = () => {
    setFormData({
      ...formData,
      organizers: [
        ...(formData.organizers || []),
        { name: '', designation: '', short_description: '', image_url: '', tag_ids: [] }
      ]
    });
  };

  const removeOrganizer = (index) => {
    const next = [...(formData.organizers || [])];
    next.splice(index, 1);
    setFormData({ ...formData, organizers: next });
  };

  const toTshirtSizesArray = (val) => {
    if (Array.isArray(val)) return val;
    if (typeof val === 'string') return val.split(',').map((s) => s.trim()).filter(Boolean);
    return [];
  };

  const updateTicket = (index, key, value) => {
    const next = [...(formData.tickets || [])];
    next[index] = { ...next[index], [key]: value };
    setFormData({ ...formData, tickets: next });
  };

  const addTicket = () => {
    setFormData({
      ...formData,
      tickets: [
        ...(formData.tickets || []),
        { title: '', description: '', features: [], price: '', adult_price: '', kids_price: '', tshirt_required: false, tshirt_sizes: [] }
      ]
    });
  };

  const removeTicket = (index) => {
    const next = [...(formData.tickets || [])];
    next.splice(index, 1);
    setFormData({ ...formData, tickets: next });
  };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4">Events</Typography>
        <Box>
          {activeTab === 0 && (
            <>
              
              <Button variant="contained" startIcon={<AddIcon />} onClick={() => handleOpen()}>
                Add Event
              </Button>
            </>
          )} 
          {activeTab === 1 && (
            <Button variant="contained" startIcon={<AddIcon />} onClick={() => openCategoryDialog()}>
              Add Category
            </Button>
          )}
          {activeTab === 2 && (
            <Button variant="contained" startIcon={<AddIcon />} onClick={() => openTagDialog()}>
              Add Tag
            </Button>
          )}
          {activeTab === 3 && (
            <Button variant="contained" startIcon={<AddIcon />} onClick={() => openCouponDialog()}>
              Add Coupon
            </Button>
          )}
          {activeTab === 4 && (
            <Button variant="outlined" startIcon={<CloudDownloadIcon />} onClick={handleExportOrders}>
              Export Orders
            </Button>
          )}
        </Box>
      </Box>

      <Tabs value={activeTab} onChange={(e, value) => setActiveTab(value)} sx={{ mb: 2 }}>
        <Tab label="Events" />
        <Tab label="Categories" />
        <Tab label="Tags" />
        <Tab label="Coupons" />
        <Tab label="Orders" />
      </Tabs>

      {activeTab === 0 && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Event Date</TableCell>
                <TableCell>End Date</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {events.map((event) => (
                <TableRow key={event.id}>
                  <TableCell>{event.id}</TableCell>
                  <TableCell>{event.title || '-'}</TableCell>
                  <TableCell>
                    {event.event_date
                      ? new Date(event.event_date).toLocaleString()
                      : '-'}
                  </TableCell>
                  <TableCell>
                    {event.end_date
                      ? new Date(event.end_date).toLocaleString()
                      : '-'}
                  </TableCell>
                  <TableCell>{event.status || '-'}</TableCell>
                  <TableCell>
                    <IconButton size="small" onClick={() => handleOpen(event)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton size="small" onClick={() => handleDelete(event.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {activeTab === 1 && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {categories.map((category) => (
                <TableRow key={category.id}>
                  <TableCell>{category.id}</TableCell>
                  <TableCell>{category.name}</TableCell>
                  <TableCell>{category.status}</TableCell>
                  <TableCell>
                    <IconButton size="small" onClick={() => openCategoryDialog(category)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton size="small" onClick={() => handleCategoryDelete(category.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {activeTab === 2 && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tags.map((tag) => (
                <TableRow key={tag.id}>
                  <TableCell>{tag.id}</TableCell>
                  <TableCell>{tag.name}</TableCell>
                  <TableCell>{tag.status}</TableCell>
                  <TableCell>
                    <IconButton size="small" onClick={() => openTagDialog(tag)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton size="small" onClick={() => handleTagDelete(tag.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {activeTab === 3 && (
        <TableContainer component={Paper}>
          {coupons.length === 0 && (
            <Box sx={{ p: 3 }}>
              <Typography color="text.secondary">No event coupons yet. Use Add Coupon to create one.</Typography>
            </Box>
          )}
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Code</TableCell>
                <TableCell>Scope</TableCell>
                <TableCell>Applies to</TableCell>
                <TableCell>Discount</TableCell>
                <TableCell>Uses</TableCell>
                <TableCell>Per email</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {coupons.map((c) => (
                <TableRow key={c.id}>
                  <TableCell>{c.id}</TableCell>
                  <TableCell>{c.code}</TableCell>
                  <TableCell>{c.scope}</TableCell>
                  <TableCell>
                    {c.scope === 'category'
                      ? (c.category_name || `Category #${c.event_category_id}`)
                      : (c.event_title || `Event #${c.event_id}`)}
                  </TableCell>
                  <TableCell>
                    {c.discount_type === 'fixed'
                      ? `₹${Number(c.discount_value || 0).toFixed(2)}`
                      : `${c.discount_value}%`}
                  </TableCell>
                  <TableCell>
                    {c.used_count ?? 0} / {c.max_uses}
                  </TableCell>
                  <TableCell>{c.max_uses_per_email}</TableCell>
                  <TableCell>{c.status}</TableCell>
                  <TableCell>
                    <IconButton size="small" onClick={() => openCouponDialog(c)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton size="small" onClick={() => handleCouponDelete(c.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {activeTab === 4 && (
        <>
          <Paper sx={{ p: 2, mb: 2 }}>
            <Box display="flex" gap={2} alignItems="center" flexWrap="wrap">
              <FormControl sx={{ minWidth: 240 }}>
                <InputLabel>Filter by Event</InputLabel>
                <Select
                  value={orderEventFilter}
                  onChange={(e) => setOrderEventFilter(e.target.value)}
                  label="Filter by Event"
                >
                  <MenuItem value="">All Events</MenuItem>
                  {events.map((event) => (
                    <MenuItem key={event.id} value={event.id}>
                      {event.title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {(() => {
                const summary = getOrderSummary(getFilteredOrders());
                return (
                  <>
                    <Typography variant="body2">
                      Total Bookings: <strong>{summary.totalBookings}</strong>
                    </Typography>
                    <Typography variant="body2">
                      Trainer Referrals: <strong>{summary.referralBookings}</strong>
                    </Typography>
                    <Typography variant="body2">
                      Total Income: <strong>₹{summary.totalIncome.toFixed(2)}</strong>
                    </Typography>
                    <Typography variant="body2">
                      T-shirt Bookings: <strong>{summary.tshirtBookings}</strong>
                    </Typography>
                  </>
                );
              })()}
            </Box>
          </Paper>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Event</TableCell>
                  <TableCell>User</TableCell>
                  <TableCell>Referral Code</TableCell>
                  <TableCell>Coupon</TableCell>
                  <TableCell>Amount</TableCell>
                  <TableCell>Payment Status</TableCell>
                  <TableCell>Bookings</TableCell>
                  <TableCell>T-shirt</TableCell>
                  <TableCell>Created</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {getFilteredOrders().map((order) => (
                  <TableRow key={order.id}>
                    <TableCell>{order.id}</TableCell>
                    <TableCell>{order.event_title || '-'}</TableCell>
                    <TableCell>{order.user_name || '-'}</TableCell>
                    <TableCell>
                      {order.referral_code || order.trainer_reference_code ? (
                        <Box>
                          <Chip
                            label={order.referral_code || order.trainer_reference_code}
                            size="small"
                            color="primary"
                            variant="outlined"
                            sx={{ fontWeight: 600 }}
                          />
                          {order.referred_trainer_name && (
                            <Typography variant="caption" color="text.secondary" display="block">
                              {order.referred_trainer_name}
                            </Typography>
                          )}
                        </Box>
                      ) : (
                        '—'
                      )}
                    </TableCell>
                    <TableCell>
                      {order.coupon_code ? (
                        <Box>
                          <Typography variant="body2">{order.coupon_code}</Typography>
                          {order.coupon_discount != null && Number(order.coupon_discount) > 0 && (
                            <Typography variant="caption" color="text.secondary" display="block">
                              −₹{Number(order.coupon_discount).toFixed(2)}
                            </Typography>
                          )}
                        </Box>
                      ) : (
                        '—'
                      )}
                    </TableCell>
                    <TableCell>₹{Number(order.total_amount || 0).toFixed(2)}</TableCell>
                    <TableCell>{order.payment_status}</TableCell>
                    <TableCell>{Number(order.attendees_count || 0)}</TableCell>
                    <TableCell>{Number(order.tshirt_count || 0)}</TableCell>
                    <TableCell>{order.created_at ? new Date(order.created_at).toLocaleString() : '-'}</TableCell>
                    <TableCell>
                      <IconButton size="small" onClick={() => openOrderDialog(order)}>
                        <EditIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}

      <Dialog open={couponDialogOpen} onClose={closeCouponDialog} maxWidth="sm" fullWidth>
        <DialogTitle>{couponEditing ? 'Edit Event Coupon' : 'Add Event Coupon'}</DialogTitle>
        <DialogContent>
          {couponError && <Alert severity="error" sx={{ mb: 2 }}>{couponError}</Alert>}
          <TextField
            fullWidth
            label="Code"
            value={couponForm.code}
            onChange={(e) => setCouponForm({ ...couponForm, code: e.target.value })}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Description"
            value={couponForm.description}
            onChange={(e) => setCouponForm({ ...couponForm, description: e.target.value })}
            margin="normal"
            multiline
            rows={2}
          />
          <FormControl fullWidth margin="normal">
            <InputLabel>Scope</InputLabel>
            <Select
              value={couponForm.scope}
              label="Scope"
              onChange={(e) => setCouponForm({ ...couponForm, scope: e.target.value })}
            >
              <MenuItem value="event">Single event</MenuItem>
              <MenuItem value="category">Event category</MenuItem>
            </Select>
          </FormControl>
          {couponForm.scope === 'event' && (
            <FormControl fullWidth margin="normal">
              <InputLabel>Event</InputLabel>
              <Select
                value={couponForm.event_id}
                label="Event"
                onChange={(e) => setCouponForm({ ...couponForm, event_id: e.target.value })}
              >
                {events.map((ev) => (
                  <MenuItem key={ev.id} value={String(ev.id)}>
                    {ev.title || `Event ${ev.id}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          {couponForm.scope === 'category' && (
            <FormControl fullWidth margin="normal">
              <InputLabel>Category</InputLabel>
              <Select
                value={couponForm.event_category_id}
                label="Category"
                onChange={(e) => setCouponForm({ ...couponForm, event_category_id: e.target.value })}
              >
                {categories.map((cat) => (
                  <MenuItem key={cat.id} value={String(cat.id)}>
                    {cat.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          <FormControl fullWidth margin="normal">
            <InputLabel>Discount type</InputLabel>
            <Select
              value={couponForm.discount_type}
              label="Discount type"
              onChange={(e) => setCouponForm({ ...couponForm, discount_type: e.target.value })}
            >
              <MenuItem value="percentage">Percentage</MenuItem>
              <MenuItem value="fixed">Fixed amount (₹)</MenuItem>
            </Select>
          </FormControl>
          <TextField
            fullWidth
            label={couponForm.discount_type === 'fixed' ? 'Discount amount (₹)' : 'Discount (%)'}
            type="number"
            value={couponForm.discount_value}
            onChange={(e) => setCouponForm({ ...couponForm, discount_value: e.target.value })}
            margin="normal"
            required
            inputProps={{ min: 0, step: couponForm.discount_type === 'fixed' ? 0.01 : 1 }}
          />
          <TextField
            fullWidth
            label="Max total uses"
            type="number"
            value={couponForm.max_uses}
            onChange={(e) => setCouponForm({ ...couponForm, max_uses: e.target.value })}
            margin="normal"
            inputProps={{ min: 1 }}
          />
          <TextField
            fullWidth
            label="Max uses per email"
            type="number"
            value={couponForm.max_uses_per_email}
            onChange={(e) => setCouponForm({ ...couponForm, max_uses_per_email: e.target.value })}
            margin="normal"
            inputProps={{ min: 1 }}
          />
          <TextField
            fullWidth
            label="Valid from"
            type="datetime-local"
            value={couponForm.valid_from}
            onChange={(e) => setCouponForm({ ...couponForm, valid_from: e.target.value })}
            margin="normal"
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            fullWidth
            label="Valid until"
            type="datetime-local"
            value={couponForm.valid_until}
            onChange={(e) => setCouponForm({ ...couponForm, valid_until: e.target.value })}
            margin="normal"
            InputLabelProps={{ shrink: true }}
          />
          <FormControl fullWidth margin="normal">
            <InputLabel>Status</InputLabel>
            <Select
              value={couponForm.status}
              label="Status"
              onChange={(e) => setCouponForm({ ...couponForm, status: e.target.value })}
            >
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="inactive">Inactive</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeCouponDialog}>Cancel</Button>
          <Button variant="contained" onClick={submitCoupon}>
            {couponEditing ? 'Save' : 'Create'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>{editing ? 'Edit Event' : 'Add Event'}</DialogTitle>
        <DialogContent>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <TextField
            fullWidth
            label="Title"
            value={formData.title}
            onChange={(e) => setFormData({ ...formData, title: e.target.value })}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Description"
            value={formData.description || ''}
            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            margin="normal"
            multiline
            rows={3}
          />
          <TextField
            fullWidth
            label="About Event"
            value={formData.about_event || ''}
            onChange={(e) => setFormData({ ...formData, about_event: e.target.value })}
            margin="normal"
            multiline
            rows={3}
          />
          <TextField
            fullWidth
            label="Event Date"
            type="datetime-local"
            value={formData.event_date}
            onChange={(e) => setFormData({ ...formData, event_date: e.target.value })}
            margin="normal"
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            fullWidth
            label="End Date"
            type="datetime-local"
            value={formData.end_date}
            onChange={(e) => setFormData({ ...formData, end_date: e.target.value })}
            margin="normal"
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            fullWidth
            label="Registration Close Date"
            type="datetime-local"
            value={formData.registration_close_date}
            onChange={(e) => setFormData({ ...formData, registration_close_date: e.target.value })}
            margin="normal"
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            fullWidth
            label="Location"
            value={formData.location || ''}
            onChange={(e) => setFormData({ ...formData, location: e.target.value })}
            margin="normal"
          />

          <FormControl fullWidth margin="normal">
            <InputLabel>State</InputLabel>
            <Select
              value={formData.state_id || ''}
              onChange={(e) => {
                setFormData({ ...formData, state_id: e.target.value, district_id: '' });
              }}
              label="State"
            >
              <MenuItem value="">Select State</MenuItem>
              {states.map((state) => (
                <MenuItem key={state.id} value={state.id}>
                  {state.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth margin="normal">
            <InputLabel>District</InputLabel>
            <Select
              value={formData.district_id || ''}
              onChange={(e) => setFormData({ ...formData, district_id: e.target.value })}
              label="District"
              disabled={!formData.state_id}
            >
              <MenuItem value="">Select District</MenuItem>
              {districts.map((district) => (
                <MenuItem key={district.id} value={district.id}>
                  {district.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            fullWidth
            label="Total Slots"
            value={formData.total_slots}
            onChange={(e) => setFormData({ ...formData, total_slots: e.target.value })}
            margin="normal"
            type="number"
          />
          <TextField
            fullWidth
            label="Image URL"
            value={formData.image_url || ''}
            onChange={(e) => setFormData({ ...formData, image_url: e.target.value })}
            margin="normal"
          />
          <Box mt={1}>
            <Typography variant="caption" color="text.secondary">
              Or upload event image
            </Typography>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setEventImageFile(e.target.files?.[0] || null)}
            />
          </Box>
          <TextField
            fullWidth
            label="External URL"
            value={formData.external_url || ''}
            onChange={(e) => setFormData({ ...formData, external_url: e.target.value })}
            margin="normal"
            placeholder="URL to the event's page on the external site"
          />
          <TextField
            fullWidth
            label="Social Media URL"
            value={formData.social_media_url || ''}
            onChange={(e) => setFormData({ ...formData, social_media_url: e.target.value })}
            margin="normal"
            placeholder="Social media link for the event"
          />
          <FormControl fullWidth margin="normal">
            <InputLabel>Categories</InputLabel>
            <Select
              multiple
              value={formData.category_ids}
              onChange={(e) => setFormData({ ...formData, category_ids: e.target.value })}
              label="Categories"
              renderValue={(selected) => {
                const selectedNames = categories
                  .filter((cat) => selected.includes(cat.id))
                  .map((cat) => cat.name);
                return selectedNames.join(', ');
              }}
            >
              {categories.map((category) => (
                <MenuItem key={category.id} value={category.id}>
                  <Checkbox checked={formData.category_ids.includes(category.id)} />
                  <ListItemText primary={category.name} />
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>Select categories for this event</FormHelperText>
          </FormControl>
          <FormControl fullWidth margin="normal">
            <InputLabel>Tags</InputLabel>
            <Select
              multiple
              value={formData.tag_ids}
              onChange={(e) => setFormData({ ...formData, tag_ids: e.target.value })}
              label="Tags"
              renderValue={(selected) => {
                const selectedNames = tags
                  .filter((tag) => selected.includes(tag.id))
                  .map((tag) => tag.name);
                return selectedNames.join(', ');
              }}
            >
              {tags.map((tag) => (
                <MenuItem key={tag.id} value={tag.id}>
                  <Checkbox checked={formData.tag_ids.includes(tag.id)} />
                  <ListItemText primary={tag.name} />
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>Select tags for this event</FormHelperText>
          </FormControl>
          <FormControl fullWidth margin="normal">
            <InputLabel>Status</InputLabel>
            <Select
              value={formData.status}
              onChange={(e) => setFormData({ ...formData, status: e.target.value })}
              label="Status"
            >
              <MenuItem value="upcoming">Upcoming</MenuItem>
              <MenuItem value="ongoing">Ongoing</MenuItem>
              <MenuItem value="completed">Completed</MenuItem>
              <MenuItem value="past">Past</MenuItem>
              <MenuItem value="cancelled">Cancelled</MenuItem>
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="inactive">Inactive</MenuItem>
            </Select>
          </FormControl>

          <Box mt={2}>
            <Typography variant="subtitle1">Event Highlights</Typography>
            {(formData.highlights || []).map((highlight, index) => (
              <Box key={`highlight-${index}`} display="flex" gap={1} mt={1}>
                <TextField
                  fullWidth
                  label={`Highlight ${index + 1}`}
                  value={highlight.highlight_text || ''}
                  onChange={(e) => updateHighlight(index, e.target.value)}
                />
                <Button variant="outlined" color="error" onClick={() => removeHighlight(index)}>
                  Remove
                </Button>
              </Box>
            ))}
            <Button sx={{ mt: 1 }} onClick={addHighlight}>Add Highlight</Button>
          </Box>

          <Box mt={2}>
            <Typography variant="subtitle1">Event Schedule</Typography>
            {(formData.schedule || []).map((item, index) => (
              <Box key={`schedule-${index}`} display="flex" gap={1} mt={1}>
                <TextField
                  label="Time"
                  value={item.schedule_time || ''}
                  onChange={(e) => updateSchedule(index, 'schedule_time', e.target.value)}
                />
                <TextField
                  label="Title"
                  value={item.title || ''}
                  onChange={(e) => updateSchedule(index, 'title', e.target.value)}
                />
                <TextField
                  label="Short Description"
                  value={item.short_description || ''}
                  onChange={(e) => updateSchedule(index, 'short_description', e.target.value)}
                />
                <Button variant="outlined" color="error" onClick={() => removeScheduleItem(index)}>
                  Remove
                </Button>
              </Box>
            ))}
            <Button sx={{ mt: 1 }} onClick={addScheduleItem}>Add Schedule Item</Button>
          </Box>

          <Box mt={2}>
            <Typography variant="subtitle1">Organizers</Typography>
            {(formData.organizers || []).map((organizer, index) => (
              <Box key={`organizer-${index}`} mt={1} p={1} border="1px solid #eee" borderRadius={1}>
                <Box display="flex" gap={1} mb={1}>
                  <TextField
                    label="Name"
                    value={organizer.name || ''}
                    onChange={(e) => updateOrganizer(index, 'name', e.target.value)}
                  />
                  <TextField
                    label="Designation"
                    value={organizer.designation || ''}
                    onChange={(e) => updateOrganizer(index, 'designation', e.target.value)}
                  />
                </Box>
                <TextField
                  fullWidth
                  label="Short Description"
                  value={organizer.short_description || ''}
                  onChange={(e) => updateOrganizer(index, 'short_description', e.target.value)}
                  margin="dense"
                />
                <TextField
                  fullWidth
                  label="Image URL"
                  value={organizer.image_url || ''}
                  onChange={(e) => updateOrganizer(index, 'image_url', e.target.value)}
                  margin="dense"
                />
                <Box mt={1}>
                  <Typography variant="caption" color="text.secondary">
                    Or upload organizer image
                  </Typography>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      const file = e.target.files?.[0];
                      if (!file) return;
                      setOrganizerImageFiles((prev) => {
                        const next = prev.filter((item) => item.index !== index);
                        next.push({ index, file });
                        return next;
                      });
                    }}
                  />
                </Box>
                <FormControl fullWidth margin="dense">
                  <InputLabel>Organizer Tags</InputLabel>
                  <Select
                    multiple
                    value={organizer.tag_ids || []}
                    onChange={(e) => updateOrganizer(index, 'tag_ids', e.target.value)}
                    label="Organizer Tags"
                    renderValue={(selected) => {
                      const selectedNames = tags
                        .filter((tag) => selected.includes(tag.id))
                        .map((tag) => tag.name);
                      return selectedNames.join(', ');
                    }}
                  >
                    {tags.map((tag) => (
                      <MenuItem key={tag.id} value={tag.id}>
                        <Checkbox checked={(organizer.tag_ids || []).includes(tag.id)} />
                        <ListItemText primary={tag.name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Button sx={{ mt: 1 }} variant="outlined" color="error" onClick={() => removeOrganizer(index)}>
                  Remove Organizer
                </Button>
              </Box>
            ))}
            <Button sx={{ mt: 1 }} onClick={addOrganizer}>Add Organizer</Button>
          </Box>

          <Box mt={2}>
            <Typography variant="subtitle1">Tickets</Typography>
            {(formData.tickets || []).map((ticket, index) => (
              <Box key={`ticket-${index}`} mt={1} p={1} border="1px solid #eee" borderRadius={1}>
                <Box display="flex" gap={1} mb={1}>
                  <TextField
                    label="Title"
                    value={ticket.title || ''}
                    onChange={(e) => updateTicket(index, 'title', e.target.value)}
                  />
                  <TextField
                    label="Price"
                    type="number"
                    value={ticket.price || ''}
                    onChange={(e) => updateTicket(index, 'price', e.target.value)}
                  />
                  <TextField
                    label="Adult Price"
                    type="number"
                    value={ticket.adult_price || ''}
                    onChange={(e) => updateTicket(index, 'adult_price', e.target.value)}
                  />
                  <TextField
                    label="Kids Price"
                    type="number"
                    value={ticket.kids_price || ''}
                    onChange={(e) => updateTicket(index, 'kids_price', e.target.value)}
                  />
                </Box>
                <TextField
                  fullWidth
                  label="Description"
                  value={ticket.description || ''}
                  onChange={(e) => updateTicket(index, 'description', e.target.value)}
                  margin="dense"
                />
                <TextField
                  fullWidth
                  label="Features (comma-separated)"
                  value={toCommaDisplay(ticket.features)}
                  onChange={(e) => updateTicket(index, 'features', e.target.value.split(',').map((f) => f.trim()))}
                  margin="dense"
                />
                <FormControl margin="dense">
                  <InputLabel>T-shirt Required</InputLabel>
                  <Select
                    value={ticket.tshirt_required ? 'yes' : 'no'}
                    label="T-shirt Required"
                    onChange={(e) => updateTicket(index, 'tshirt_required', e.target.value === 'yes')}
                  >
                    <MenuItem value="no">No</MenuItem>
                    <MenuItem value="yes">Yes</MenuItem>
                  </Select>
                </FormControl>
                {ticket.tshirt_required && (
                  <TextField
                    fullWidth
                    label="T-shirt Sizes (comma-separated)"
                    value={toCommaDisplay(ticket.tshirt_sizes)}
                    onChange={(e) => updateTicket(index, 'tshirt_sizes', e.target.value.split(',').map((f) => f.trim()))}
                    margin="dense"
                  />
                )}
                <Button sx={{ mt: 1 }} variant="outlined" color="error" onClick={() => removeTicket(index)}>
                  Remove Ticket
                </Button>
              </Box>
            ))}
            <Button sx={{ mt: 1 }} onClick={addTicket}>Add Ticket</Button>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSubmit} variant="contained">
            {editing ? 'Update' : 'Create'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Pull Events Dialog */}
      {/* <Dialog open={pullDialogOpen} onClose={() => setPullDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Pull All Events from External API</DialogTitle>
        <DialogContent>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <TextField
            fullWidth
            label="External API URL"
            value={pullFormData.external_api_url}
            onChange={(e) => setPullFormData({ ...pullFormData, external_api_url: e.target.value })}
            margin="normal"
            required
            placeholder="https://api.example.com/events"
          />
          <TextField
            fullWidth
            label="API Key (Optional)"
            type="password"
            value={pullFormData.api_key}
            onChange={(e) => setPullFormData({ ...pullFormData, api_key: e.target.value })}
            margin="normal"
            placeholder="Bearer token or API key"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPullDialogOpen(false)} disabled={pulling}>Cancel</Button>
          <Button onClick={handlePullEvents} variant="contained" disabled={pulling || !pullFormData.external_api_url}>
            {pulling ? 'Pulling...' : 'Pull Events'}
          </Button>
        </DialogActions>
      </Dialog> */}

      {/* Category Dialog */}
      <Dialog open={categoryDialogOpen} onClose={() => setCategoryDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{categoryForm.id ? 'Edit Category' : 'Add Category'}</DialogTitle>
        <DialogContent>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <TextField
            fullWidth
            label="Category Name"
            value={categoryForm.name}
            onChange={(e) => setCategoryForm({ ...categoryForm, name: e.target.value })}
            margin="normal"
            required
          />
          <FormControl fullWidth margin="normal">
            <InputLabel>Status</InputLabel>
            <Select
              value={categoryForm.status}
              onChange={(e) => setCategoryForm({ ...categoryForm, status: e.target.value })}
              label="Status"
            >
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="inactive">Inactive</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCategoryDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleCategorySave} variant="contained">
            {categoryForm.id ? 'Update' : 'Create'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Tag Dialog */}
      <Dialog open={tagDialogOpen} onClose={() => setTagDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{tagForm.id ? 'Edit Tag' : 'Add Tag'}</DialogTitle>
        <DialogContent>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <TextField
            fullWidth
            label="Tag Name"
            value={tagForm.name}
            onChange={(e) => setTagForm({ ...tagForm, name: e.target.value })}
            margin="normal"
            required
          />
          <FormControl fullWidth margin="normal">
            <InputLabel>Status</InputLabel>
            <Select
              value={tagForm.status}
              onChange={(e) => setTagForm({ ...tagForm, status: e.target.value })}
              label="Status"
            >
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="inactive">Inactive</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setTagDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleTagSave} variant="contained">
            {tagForm.id ? 'Update' : 'Create'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Order Details Dialog */}
      <Dialog open={orderDialogOpen} onClose={() => setOrderDialogOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>Order Details</DialogTitle>
        <DialogContent>
          {selectedOrder && (
            <Box>
              <Typography variant="subtitle1" gutterBottom>
                {selectedOrder.event_title}
              </Typography>
              <Typography variant="body2">User: {selectedOrder.user_name} ({selectedOrder.user_email})</Typography>
              {selectedOrder.subtotal_before_coupon != null && selectedOrder.subtotal_before_coupon !== '' && (
                <Typography variant="body2" color="text.secondary">
                  Subtotal (before coupon): ₹{Number(selectedOrder.subtotal_before_coupon).toFixed(2)}
                </Typography>
              )}
              {selectedOrder.coupon_discount != null && Number(selectedOrder.coupon_discount) > 0 && (
                <Typography variant="body2" color="success.main">
                  Coupon discount: −₹{Number(selectedOrder.coupon_discount).toFixed(2)}
                </Typography>
              )}
              <Typography variant="body2">Amount paid: ₹{Number(selectedOrder.total_amount || 0).toFixed(2)}</Typography>
              <Typography variant="body2" sx={{ mb: 2 }}>Status: {selectedOrder.payment_status}</Typography>

              {(selectedOrder.referral_code || selectedOrder.trainer_reference_code || selectedOrder.referred_trainer_name) && (
                <Box sx={{ mb: 2, p: 2, bgcolor: '#f0fdf4', borderRadius: 1, border: '1px solid #bbf7d0' }}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#166534', mb: 0.5 }}>
                    Trainer Referral
                  </Typography>
                  <Typography variant="body2">
                    <strong>Referral Code:</strong> {selectedOrder.referral_code || selectedOrder.trainer_reference_code || '—'}
                  </Typography>
                  {selectedOrder.referred_trainer_name && (
                    <Typography variant="body2">
                      <strong>Referred Trainer:</strong> {selectedOrder.referred_trainer_name}
                      {selectedOrder.referred_trainer_email ? ` (${selectedOrder.referred_trainer_email})` : ''}
                      {selectedOrder.referred_trainer_phone ? ` - ${selectedOrder.referred_trainer_phone}` : ''}
                    </Typography>
                  )}
                </Box>
              )}

              {(selectedOrder.coupon ||
                selectedOrder.coupon_redemption ||
                selectedOrder.event_coupon_id ||
                (selectedOrder.subtotal_before_coupon != null &&
                  selectedOrder.subtotal_before_coupon !== '')) && (
                <Box sx={{ mb: 2, p: 2, bgcolor: 'action.hover', borderRadius: 1 }}>
                  <Typography variant="subtitle2" gutterBottom>
                    Coupon &amp; redemption
                  </Typography>
                  {selectedOrder.coupon ? (
                    <>
                      <Typography variant="body2">
                        <strong>Code:</strong> {selectedOrder.coupon.code}
                      </Typography>
                      {selectedOrder.coupon.description && (
                        <Typography variant="body2">{selectedOrder.coupon.description}</Typography>
                      )}
                      <Typography variant="body2">
                        <strong>Scope:</strong> {selectedOrder.coupon.scope}
                        {selectedOrder.coupon.scope === 'category' && selectedOrder.coupon.category_name
                          ? ` — ${selectedOrder.coupon.category_name}`
                          : ''}
                        {selectedOrder.coupon.scope === 'event' && selectedOrder.coupon.target_event_id
                          ? ` (event #${selectedOrder.coupon.target_event_id})`
                          : ''}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Rule:</strong>{' '}
                        {selectedOrder.coupon.discount_type === 'fixed'
                          ? `₹${Number(selectedOrder.coupon.discount_value || 0).toFixed(2)} off`
                          : `${selectedOrder.coupon.discount_value}% off`}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Limits: {selectedOrder.coupon.max_uses_per_email} use(s) per email, {selectedOrder.coupon.max_uses}{' '}
                        total uses (global cap on the coupon)
                      </Typography>
                    </>
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      Coupon record missing (order still has discount fields below).
                    </Typography>
                  )}
                  {selectedOrder.coupon_redemption ? (
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      <strong>Redemption:</strong> ID {selectedOrder.coupon_redemption.id} — email{' '}
                      {selectedOrder.coupon_redemption.user_email} at{' '}
                      {selectedOrder.coupon_redemption.created_at
                        ? new Date(selectedOrder.coupon_redemption.created_at).toLocaleString()
                        : '—'}
                      . This row is created when checkout succeeds with a valid code; it enforces per-email limits and
                      pairs with the coupon&apos;s global <code>used_count</code>.
                    </Typography>
                  ) : selectedOrder.event_coupon_id ? (
                    <Typography variant="body2" color="warning.main" sx={{ mt: 1 }}>
                      No redemption row found for this order (unexpected if coupon was applied).
                    </Typography>
                  ) : null}
                </Box>
              )}

              <FormControl fullWidth margin="normal">
                <InputLabel>Payment Status</InputLabel>
                <Select
                  value={selectedOrder.payment_status || 'pending'}
                  onChange={(e) => setSelectedOrder({ ...selectedOrder, payment_status: e.target.value })}
                  label="Payment Status"
                >
                  <MenuItem value="pending">Pending</MenuItem>
                  <MenuItem value="success">Success</MenuItem>
                  <MenuItem value="failed">Failed</MenuItem>
                  <MenuItem value="refunded">Refunded</MenuItem>
                </Select>
              </FormControl>
              <TextField
                fullWidth
                label="Payment Provider"
                value={selectedOrder.payment_provider || ''}
                onChange={(e) => setSelectedOrder({ ...selectedOrder, payment_provider: e.target.value })}
                margin="normal"
              />
              <TextField
                fullWidth
                label="Payment ID"
                value={selectedOrder.payment_id || ''}
                onChange={(e) => setSelectedOrder({ ...selectedOrder, payment_id: e.target.value })}
                margin="normal"
              />
              <TextField
                fullWidth
                label="Payment Signature"
                value={selectedOrder.payment_signature || ''}
                onChange={(e) => setSelectedOrder({ ...selectedOrder, payment_signature: e.target.value })}
                margin="normal"
              />

              <Box mt={2}>
                <Typography variant="subtitle2">Attendees</Typography>
                {(selectedOrder.attendees || []).map((attendee) => (
                  <Box key={attendee.id} display="flex" justifyContent="space-between" mt={1}>
                    <Typography variant="body2">
                      {attendee.name} ({attendee.age_group})
                    </Typography>
                    <Typography variant="body2">{attendee.ticket_title || 'Ticket'}</Typography>
                    <Typography variant="body2">{attendee.tshirt_size || '-'}</Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOrderDialogOpen(false)}>Close</Button>
          <Button onClick={handleOrderPaymentUpdate} variant="contained">
            Update Payment
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default Events;